export default __webpack_public_path__ + "static/media/ticket-two.48db724b.svg";